/* global axios */
import ApiClient from './ApiClient';

class PipelineAutomationTemplatesAPI extends ApiClient {
  constructor() {
    super('pipeline/automation_templates', { accountScoped: true });
  }

  async list(params = {}) {
    const response = await axios.get(this.url, { params });
    return response;
  }

  async use(id, name = null) {
    const payload = name ? { name } : {};
    const response = await axios.post(`${this.url}/${id}/use`, payload);
    return response;
  }
}

export default new PipelineAutomationTemplatesAPI();
